import React from "react";

import "./Footer.scss";

import email from "images/icons/email.png";
import mailbox from "images/icons/mailbox.png";
import phone from "images/icons/phone.png";
import website from "images/icons/website.png";

export default function Footer() {
  return (
    <div className="Footer">
      <footer className="footer">
        <div className="columns is-multiline">
          <div className="column is-full">
            <div className="flex-row justify-center">
              <img src={mailbox} className="is-larger" alt="" />
              <span>
                <span className="has-text-weight-semibold">
                  教育評議會 Education Convergence
                </span>
                <br />
                新界上水青城路8號風采中學
                <br />
                Elegantia College, 8 Ching Shing Road, Sheung Shui, N.T.
              </span>
            </div>
          </div>
          <div className="column is-one-third-tablet">
            <div className="flex-row justify-center">
              <img src={phone} alt="" />
              <span>3468 5745</span>
            </div>
          </div>
          <div className="column is-one-third-tablet">
            <div className="flex-row justify-center">
              <img src={email} alt="" />
              <a href="mailto:edconvergence.qef@gmail.com">
                edconvergence.qef@gmail.com
              </a>
            </div>
          </div>
          <div className="column is-one-third-tablet">
            <div className="flex-row justify-center">
              <img src={website} alt="" />
              <a
                target="_blank"
                rel="noreferrer"
                href="http://www.edconvergence.org.hk/"
              >
                www.edconvergence.org.hk
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
